// Ingestion is reverse-proxied through our own domain (ad-blocker resilience) —
// one host for both the browser and server SDKs, not configurable.
export const POSTHOG_HOST = 'https://p.cognitory.ai';
